import { render, staticRenderFns, recyclableRender, components } from "./article-details.vue?vue&type=template&id=c5e2a444&scoped=true&"
var renderjs
import script from "./article-details.vue?vue&type=script&lang=js&"
export * from "./article-details.vue?vue&type=script&lang=js&"
import style0 from "./article-details.vue?vue&type=style&index=0&id=c5e2a444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e2a444",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/article-details/article-details.vue"
export default component.exports